module.exports = "/_next/static/images/user-placeholder-cdaaa47781add1cc5be37aed2dcdaf7e.svg";